import React, {
    useState,
    useEffect,
} from "react";

export const FieldPage = (statekoneprops) => {
    // console.log("PROPS OF PAGE: ", statekoneprops)
    const [page, setPage] = useState()
    const [metaData, setMetaData] = useState({})
    const [finalEngine, setFinalEngine] = useState()
    const [stateKoneFieldsMapper, setStateKoneFieldsMapper] = useState({})
    const [K1TemplateId, setK1TemplateId] = useState()
    const [poppyState, setPoppyState] = useState(false)
    const [activeFootnote, setActiveFootnote] = useState("")
    const [activeFootnoteData, setActiveFootnoteData] = useState("")
    const [pageFileLink, setPageFileLink] = useState("")
    const heightConversionFactor = 709 / (statekoneprops.sectionDimensions?.height ?? 1);
    const widthConversionFactor = 550 / (statekoneprops.sectionDimensions?.width ?? 1);
    const leftOffset = (statekoneprops.sectionDimensions?.left ?? 70) - 70;

    /**
     * Capturing metadata changes to the active K-1 page
     */
    useEffect(() => {
        if (statekoneprops.metadata !== undefined) {
            setMetaData(statekoneprops.metadata)
        }
    }, [statekoneprops.metadata])

    /**
     * Update the page link on every page change
     */
    useEffect(() => {
        setPageFileLink(statekoneprops.filelink)
    }, [statekoneprops.filelink])


    /**
     * Update the Final Engine data for the active K-1 page
     */
    useEffect(() => {
        if (statekoneprops.finalenginedata !== undefined) {
            setFinalEngine(statekoneprops.finalenginedata)
        }
    }, [statekoneprops.finalenginedata])


    /** Update the page number for active K-1 page */
    useEffect(() => {
        if (statekoneprops.page !== undefined) {
            setPage(statekoneprops.page)
        }
    }, [statekoneprops.page])


    /**
     * Send the updated data on a page whenever page changes to keep it in cache
     */
    useEffect(() => {
        if (K1TemplateId !== undefined) {
            // console.log(K1TemplateId)
            statekoneprops.updatefields(statekoneprops.page, K1TemplateId, stateKoneFieldsMapper)
        }
    }, [K1TemplateId])

    /**
     * Send the updated data on a page whenever data changes to update the cache
     */
    useEffect(() => {
        // console.log("STATE KONE FIELD MAPPER: ", stateKoneFieldsMapper)
        statekoneprops.updatefields(statekoneprops.page, K1TemplateId, stateKoneFieldsMapper)
    }, [stateKoneFieldsMapper])

    /**
     * 
     */
    useEffect(() => {
        console.log(finalEngine)
        if (finalEngine !== undefined) {
            Object.assign(stateKoneFieldsMapper, finalEngine["result"])
            setStateKoneFieldsMapper(finalEngine["result"])
            setK1TemplateId(finalEngine["K1TemplateId"])
        }
    }, [finalEngine])

    /**
     * Function to update the final engine data based on changes that were done by the user
     * @param {*} field : Field to be updated in the final engine data map
     * @param {*} value : Final engine data map
     */
    const updateField = (field, value) => {
        setStateKoneFieldsMapper(skfm => ({ ...skfm, [field]: value }))
        // console.log("CHANGED MAP: ", {stateKoneFieldsMapper, [field]:value})
    }

    return (
        <>
            <div
                style={{
                    position: "absolute",
                    boxShadow: "1px 1px 0px 1px rgba(240, 240, 240, 0.05)",
                    left: 0
                }} >
                {
                    Object.keys(metaData).length > 0 ?
                        <>
                            {
                                Object.keys(metaData["Page 1"]["Checkbox Coordinates"]).map((field) =>
                                    <div style={{
                                        position: "absolute",
                                        zIndex: 1,
                                        top: `${metaData["Page 1"]["Checkbox Coordinates"][field]["y"] / heightConversionFactor}px`,
                                        left: `${leftOffset + metaData["Page 1"]["Checkbox Coordinates"][field]["x"] / widthConversionFactor}px`,
                                        width: `${metaData["Page 1"]["Checkbox Coordinates"][field]["w"] / widthConversionFactor}px`,
                                        height: `${metaData["Page 1"]["Checkbox Coordinates"][field]["h"] / heightConversionFactor}px`
                                    }}>
                                        <input type="checkbox"
                                            className={
                                                "kone-text-field-check field-changed-green"
                                            }
                                            style={{ textAlign: `${metaData["Page 1"]["Checkbox Coordinates"][field]["align"]}` }}
                                            checked={stateKoneFieldsMapper[field] === "True" || stateKoneFieldsMapper[field] === "true" || stateKoneFieldsMapper[field] === true ? true : false}
                                            onChange={(event) => updateField(field, event.target.checked)}
                                            autoComplete="new-password"
                                        />
                                    </div>
                                )
                            }
                            {
                                Object.keys(metaData["Page 1"]["Text Coordinates"]).map((field) => {
                                    if (stateKoneFieldsMapper[field] && stateKoneFieldsMapper[field].includes("\n")) {
                                        return (
                                            <div style={{
                                                position: "absolute",
                                                zIndex: 1,
                                                top: `${metaData["Page 1"]["Text Coordinates"][field]["y"] / heightConversionFactor}px`,
                                                left: `${leftOffset + metaData["Page 1"]["Text Coordinates"][field]["x"] / widthConversionFactor}px`,
                                                width: `${metaData["Page 1"]["Text Coordinates"][field]["w"] / widthConversionFactor}px`,
                                                height: `${metaData["Page 1"]["Text Coordinates"][field]["h"] / heightConversionFactor}px`
                                            }}>
                                                <textarea
                                                    type="textarea"
                                                    rows={3}
                                                    className={
                                                        "kone-text-field field-changed-green"
                                                    }
                                                    style={{ textAlign: `${metaData["Page 1"]["Text Coordinates"][field]["align"]}` }}
                                                    value={stateKoneFieldsMapper[field]}
                                                    onChange={(event) => { updateField(field, event.target.value) }}
                                                    autoComplete="new-password"
                                                />
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div style={{
                                                position: "absolute",
                                                zIndex: 1,
                                                top: `${metaData["Page 1"]["Text Coordinates"][field]["y"] / heightConversionFactor}px`,
                                                left: `${leftOffset + metaData["Page 1"]["Text Coordinates"][field]["x"] / widthConversionFactor}px`,
                                                width: `${metaData["Page 1"]["Text Coordinates"][field]["w"] / widthConversionFactor}px`,
                                                height: `${metaData["Page 1"]["Text Coordinates"][field]["h"] / heightConversionFactor}px`
                                            }}>
                                                {
                                                    true
                                                        ?
                                                        <input type="text"
                                                            className={
                                                                "kone-text-field field-changed-green"
                                                            }
                                                            style={{ textAlign: `${metaData["Page 1"]["Text Coordinates"][field]["align"]}`, border: "3px solid black" }}
                                                            value={stateKoneFieldsMapper[field]}
                                                            onChange={(event) => { updateField(field, event.target.value) }}
                                                            autoComplete="new-password"
                                                        />
                                                        : <input type="text"
                                                            className={
                                                                "kone-text-field field-changed-green"
                                                            }
                                                            style={{ textAlign: `${metaData["Page 1"]["Text Coordinates"][field]["align"]}` }}
                                                            value={stateKoneFieldsMapper[field]}
                                                            onChange={(event) => { updateField(field, event.target.value) }}
                                                            autoComplete="new-password"
                                                        />
                                                }

                                            </div>
                                        )
                                    }
                                })}
                        </>
                        :
                        <></>
                }
            </div>
        </>
    )
}
